import { motion } from 'framer-motion'

const socials = [
  { label: 'Instagram', href: '#' },
  { label: 'TikTok', href: '#' },
  { label: 'YouTube', href: '#' },
  { label: 'Hotmart', href: '#' },
]

export default function Footer() {
  return (
    <footer
      className="relative"
      style={{ borderTop: '1px solid var(--line)', background: 'var(--bg)' }}
    >
      <div
        className="flex flex-col md:flex-row items-center justify-between gap-6 px-[5vw] py-14"
      >
        <span
          className="font-display font-black text-[13px] tracking-[0.14em] uppercase"
          style={{ color: 'var(--gold)' }}
        >
          Medicina con Dante
        </span>

        <div className="flex flex-wrap gap-8 justify-center">
          {socials.map(s => (
            <motion.a
              key={s.label}
              href={s.href}
              className="font-body text-[12px] tracking-[0.05em] transition-colors duration-200"
              style={{ color: 'var(--ink-3)' }}
              whileHover={{ color: 'var(--gold)' }}
            >
              {s.label}
            </motion.a>
          ))}
        </div>

        <span
          className="font-body text-[12px]"
          style={{ color: 'var(--ink-3)' }}
        >
          © 2025 · Todos los derechos reservados
        </span>
      </div>

      {/* Bottom gold line accent */}
      <div
        className="absolute bottom-0 left-0 right-0 h-[1px] pointer-events-none"
        style={{
          background: 'linear-gradient(90deg, transparent, var(--gold) 30%, var(--gold) 70%, transparent)',
          opacity: 0.15,
        }}
      />
    </footer>
  )
}